import { Dropdown } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import PeriodEditor from './PeriodEditor';
import useOption from 'components/customHooks';
import PopupContext from 'contexts/PopupContext';
import ReferenceRate from '../../../../../../models/data/ReferenceRate';
import Period from '../../../../../../models/data/Period';
const ReferenceRateEditor = ({ disabled, onChange, style, value }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [period, setPeriod] = React.useState(value?.designatedMaturity ?? new Period({ period: 'M', periodMultiplier: 3 }));
    const [benchmark, setBenchmark] = React.useState(value?.benchmark);
    const benchmarkOptions = useOption('/syndicate/overview/ir-benchmark/options', { sort: false });
    const [hasPeriod, setHasPeriod] = React.useState(true);
    React.useEffect(() => {
        const option = benchmarkOptions.find(o => 'value' in o && o.value === value?.benchmark);
        if (option !== undefined) {
            setHasPeriod('data' in option ? (option.data ?? true) : true);
        }
    }, [benchmarkOptions, value?.benchmark]);
    const set = React.useCallback((newRate, newHasPeriod) => {
        const value = (newRate.designatedMaturity !== undefined || !newHasPeriod) && newRate.benchmark !== undefined ? new ReferenceRate({ benchmark: newRate.benchmark, designatedMaturity: newRate.designatedMaturity }) : undefined;
        onChange({ target: { value } });
    }, [onChange]);
    const onChangeBenchmark = React.useCallback((event) => {
        const newValue = event.target.value.value;
        setBenchmark(newValue);
        const newHasPeriod = event.target.value.data ?? true;
        setHasPeriod(newHasPeriod);
        if (!newHasPeriod) {
            setPeriod(undefined);
            set({ designatedMaturity: undefined, benchmark: newValue, }, newHasPeriod);
        }
        else {
            set({ designatedMaturity: period, benchmark: newValue }, newHasPeriod);
        }
    }, [set, period]);
    const onChangePeriod = React.useCallback((event) => {
        setPeriod(event.target.value);
        set({ designatedMaturity: event.target.value, benchmark }, hasPeriod);
    }, [set, benchmark, hasPeriod]);
    const onMenuOpen = React.useCallback(() => {
        setBlockClose(true);
    }, [setBlockClose]);
    const onMenuClose = React.useCallback(() => {
        setBlockClose(false);
    }, [setBlockClose]);
    const finalStyle = React.useMemo(() => {
        const baseStyle = { display: 'flex' };
        return style !== undefined ? Object.assign(style, baseStyle) : baseStyle;
    }, [style]);
    if (benchmarkOptions.length === 0) {
        return undefined;
    }
    return (React.createElement("div", { style: finalStyle },
        hasPeriod ?
            React.createElement(PeriodEditor, { defaultPeriod: 'M', onChange: onChangePeriod, style: { marginRight: '0.5rem' }, value: period }) : undefined,
        React.createElement("div", { className: "co-benchmark-dropdown", style: { width: '7rem' } },
            React.createElement(Dropdown, { disabled: disabled, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, options: benchmarkOptions, onChange: onChangeBenchmark, value: benchmarkOptions.find(o => 'value' in o && o.value === benchmark) }))));
};
export default ReferenceRateEditor;
